module.exports = __webpack_public_path__ + "produce-fresh-grass-16.jpg?13fa78988c11e2400f86686cb5c7ba29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-16.jpg
// module id = 53
// module chunks = 0